<!--
 * @Author: your name
 * @Date: 2020-09-25 10:50:24
 * @LastEditTime: 2020-10-14 11:36:00
 * @LastEditors: jml
 * @Description: In User Settings Edit
 * @FilePath: \saas-polymerization-c\src\views\game\puzzle\index.vue
-->
<template>
  <div class="puzzle">
    <div class="stance-1">
      <img src="../img/puzzle/bg2.png" alt class="bg absolute" />
      <img src="../img/puzzle/title.png" alt class="title" />
      <img src="../img/puzzle/rule-5.png" class="rule absolute" @click="toRulePage" alt />
      <!-- <van-icon name="question-o" class="rule absolute" @click="toRulePage" /> -->
      <img src="../img/puzzle/i.png" class="i absolute" />
      <div class="time">
        <span>时间:</span>
        <span
          v-for="(item,index) in dealTime(sTime)"
          :class="{number:item!='.'}"
          :key="index"
        >{{item}}</span>
        <span>秒</span>
      </div>
      <div class="game-box">
        <div class="block">
          <div
            class="block"
            v-if="pics.length>0"
            :class="{n:pics.length==9,m:pics.length==16,h:pics.length==25}"
          >
            <div
              class="card"
              :class="{move:moveIndex == index}"
              v-for="(item,index) in pics"
              :key="index"
              @touchstart="start"
              @touchend="end"
              @touchmove="move"
            >
              <img :src="item" alt />
            </div>
            <div
              class="move-card card"
              v-if="moveUrl"
              :style="{left:`${moveUrlLeft}px`,top:`${moveUrlTop}px`}"
            >
              <img :src="moveUrl" alt />
            </div>
          </div>
          <div
            v-else
            class="block big-block"
            :class="{n:info.ptNumber==9,m:info.ptNumber==16,h:info.ptNumber==25,isstop:!gameIsStart}"
          >
            <div
              class="card"
              :class="{move:moveIndex == index}"
              v-for="(item,index) in info.ptNumber"
              :key="index"
              @touchstart="start"
              @touchend="end"
              @touchmove="move"
            >
              <div
                class="img-box"
                :style="{
                backgroundImage:`url(${info.ptUrl})`,
                backgroundPositionX:-parseInt(localArr[index]%Math.sqrt(info.ptNumber))*itemWidthInfo[info.ptNumber]+'rem',
                backgroundPositionY:-parseInt(localArr[index]/Math.sqrt(info.ptNumber))*itemWidthInfo[info.ptNumber]+'rem',
              }"
              ></div>
            </div>
            <div
              class="move-card card"
              v-if="moveIndex>-1"
              :style="{
                position:'absolute',
                left:`${moveUrlLeft}px`,
                top:`${moveUrlTop}px`}"
            >
              <div
                class="img-box"
                :style="{
                backgroundImage:`url(${info.ptUrl})`,
                backgroundPositionX:-parseInt(localArr[moveIndex]%Math.sqrt(info.ptNumber))*itemWidthInfo[info.ptNumber]+'rem',
                backgroundPositionY:-parseInt(localArr[moveIndex]/Math.sqrt(info.ptNumber))*itemWidthInfo[info.ptNumber]+'rem',}"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="showBtn">
        <!-- 还有机会 -->
        <img src="../img/puzzle/btn.png" class="btn" v-if="todayCount>0" alt @click="startGame" />
        <!-- 没有机会 -->
        <template v-else>
          <!-- 分享增加次数 -->
          <lShare class="btn" v-if="info.isOpenShareSum==1"></lShare>
          <!-- 分享不增加次数 -->
          <img src="../img/puzzle/btn-2.png" class="btn" v-else alt />
        </template>
        <div class="tips" v-if="todayCount>0 || info.isOpenShareSum!=1">今天还有{{todayCount||0}}次游戏机会</div>
        <div v-else class="tips">每日分享后，新用户完成注册将再获得{{info.shareSum||0}}次游戏机会</div>
      </template>
    </div>
    <lSuccess
      v-if="showSuccess"
      :nowGameTime="dealTime(sTime)"
      @palyAgain="palyAgain"
      @back="showSuccess = false"
      @hasEntity="showAddressDialog"
    ></lSuccess>
    <template v-if="!isPreview">
      <lEnd v-if="gameIsEnd"></lEnd>
      <lUnreleased v-if="gameIsNotRelease"></lUnreleased>
    </template>
  </div>
</template>

<script>
import lSuccess from './components/success';
import lShare from './components/share';
import { mapeMutations, mapActions, mapState } from 'vuex';
import { puzzle } from '@/api/game';
import { dealTime } from '../config/util';
import lAddress from '../components/address';
import { game } from '../mixins/game';
import lEnd from '../components/end';
import lUnreleased from '../components/unreleased';
import { customerUser } from '@/api/ajax';
import { getStorage } from '@/utils/storage';
export default {
  name: 'puzzleGameRule',
  components: { lSuccess, lShare, lEnd, lUnreleased },
  mixins: [game],
  data() {
    return {
      moveIndex: -1,
      nowIndex: 0,
      pics: [],
      moveUrl: '',
      moveUrlLeft: 0,
      moveUrlTop: 0,
      sTime: 0,
      detailId: 0,
      todayCount: 0,
      showSuccess: false,
      gameIsStart: false,
      showBtn: false,
      dealTime,
      itemWidthInfo: {
        9: 2.612,
        16: 1.9,
        25: 1.55
      },
      localArr: [],
      hiddenTime: new Date().getTime(),
      nowTime: new Date().getTime()
    };
  },
  computed: {
    ...mapState({
      info: state => state.game.info
    }),
    gameIsEnd() {
      return this.info.endDt && this.info.endDt < this.nowTime;
    },
    gameIsNotRelease() {
      return 'isRelease' in this.info && this.info.isRelease != 1;
    }
  },
  methods: {
    getActiveInfo(channelNo, activityId) {
      puzzle.activityData({ channelNo, activityId }).then(res => {
        const { tJhEnterpriseActivityRule, prizeList } = res.data.data;
        this.localSetInfo(tJhEnterpriseActivityRule, true);
        this.localSetRewards(prizeList);
        this.setShareUrl();
      });
    },
    toRulePage() {
      if (this.isEdit && !this.isPreview) {
        return;
      }
      this.$router.push({
        name: 'puzzleGameRule',
        query: this.$route.query
      });
    },
    getIndex(x, y, fontSize) {
      let length = 0;
      if (this.isPreview) {
        length = this.localArr.length;
      } else {
        length = this.pics.length;
      }
      let itemSize = 0;
      let index = 0;
      let moveOut = false;
      if (length == 25) {
        itemSize = fontSize * 1.64;
        index = x + y * 5;
      }
      if (length == 16) {
        itemSize = fontSize * 2.05;
        index = x + y * 5;
      }
      if (length == 9) {
        itemSize = fontSize * 2.73;
        index = x + y * 5;
      }
      const _xd = x / itemSize;
      const _yd = y / itemSize;
      const _x = _xd < 0 && _xd > -1 ? -1 : parseInt(x / itemSize);
      const _y = _yd < 0 && _yd > -1 ? -1 : parseInt(y / itemSize);
      if (
        _x < 0 ||
        _y < 0 ||
        _x >= Math.sqrt(length) ||
        _y >= Math.sqrt(length)
      ) {
        // 移出了盒子
        // this.moveIndex = -1;
        // this.moveUrl = '';
        moveOut = true;
      }
      if (length == 25) {
        index = _x + _y * 5;
      }
      if (length == 16) {
        index = _x + _y * 4;
      }
      if (length == 9) {
        index = _x + _y * 3;
      }
      return { index, itemSize, _x, _y, moveOut };
    },
    getOffset(e) {
      e.stopPropagation();
      e.preventDefault();
      const { pageX, pageY } = e.changedTouches[0];
      const fontSize = document
        .getElementsByTagName('html')[0]
        .style.fontSize.slice(0, -2);
      const intoZoom = 1;
      const width = document.body.offsetWidth;
      const height = document.body.offsetHeight;
      const x = Math.floor(pageX - (width - fontSize * 8.6 * intoZoom) / 2);
      const y = Math.floor(pageY - fontSize * 4.5 * intoZoom);
      return { x, y, ...this.getIndex(x, y, fontSize) };
    },
    moveItem(x, y, _x, _y, itemSize, isStart) {
      if (this.gameOver || !this.localGameIsStart) {
        return;
      }
      if (isStart) {
        this.moveUrlInitLeft = x - _x * itemSize - 10;
        this.moveUrlInitTop = y - _y * itemSize - 10;
      }
      this.moveUrlLeft = x - this.moveUrlInitLeft;
      this.moveUrlTop = y - this.moveUrlInitTop;
    },
    start(e) {
      if (this.gameOver || !this.localGameIsStart) {
        return;
      }
      const { x, y, index, itemSize, _x, _y } = this.getOffset(e);
      // 处理移动的拼图块超出边界的情况
      if (!this.isPreview && index >= this.pics.length) {
        return;
      }
      // 处理移动的拼图块超出边界的情况
      if (this.isPreview && index >= this.localArr.length) {
        return;
      }
      this.moveIndex = index;
      this.moveUrl = this.pics[index];
      this.moveItem(x, y, _x, _y, itemSize, true);
    },
    end(e) {
      if (this.gameOver || !this.localGameIsStart) {
        return;
      }
      const { x, y, index, moveOut } = this.getOffset(e);
      if (this.moveIndex > -1 && this.moveIndex != index && !moveOut) {
        const nowPintuArr = this.isPreview
          ? [...this.localArr]
          : [...this.pics];
        [nowPintuArr[index], nowPintuArr[this.moveIndex]] = [
          nowPintuArr[this.moveIndex],
          nowPintuArr[index]
        ];
        if (this.isPreview) {
          this.localArr = nowPintuArr;
        } else {
          this.pics = nowPintuArr;
        }
      }
      this.moveIndex = -1;
      this.moveUrl = '';
      if (this.isPreview) {
        this.localJudgeComplete();
      } else {
        this.judgeComplete();
      }
    },
    move(e) {
      const { x, y, index } = this.getOffset(e);
      this.moveItem(x, y);
    },
    showAddressDialog() {
      setTimeout(() => {
        if (this.showSuccess) {
          this.$xrkDialog({
            content: lAddress,
            hideConfirm: true,
            confirmText: '完成',
            title: '恭喜您进入排行榜，有可能获得奖品，请填写收货地址',
            callback: params => {
              this.$toast.success('填写成功');
            }
          });
        }
      }, 3000);
    },
    randomPuzzleArr() {
      const arr = this.localArr;
      const newArr = [];
      const len = arr.length;
      for (let i = 0; i < len; i++) {
        let index = Math.floor(Math.random() * arr.length); //随机下标
        newArr.push(arr[index]); //将随机出的元素，存放新数组newArr中去
        arr.splice(index, 1); //    将随机出的元素在arr中删除
      }
      this.localArr = [...newArr, ...arr];
    },
    async getPics() {
      const { id, channelNo } = this.$route.params;
      const {
        data: { data }
      } = await puzzle.sudokuImage({ channelNo, activityId: id });
      const { imageList = [], activityDetail = {} } = data;
      this.pics = imageList;
      this.detailId = activityDetail.id;
    },
    async judgeComplete() {
      const { id, channelNo } = this.$route.params;
      const {
        data: { data, message }
      } = await puzzle
        .judgeComplete({
          channelNo,
          activityId: id,
          detailId: this.detailId,
          imageList: this.pics.join(',')
        })
        .catch(err => {
          const message = (err || {}).message;
          if (message == '您已被拉黑,请确认!') {
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        });
      if (data) {
        this.sTime = data / 10;
        this.gameOver = true;
        this.showSuccess = true;
        this.gameIsStart = false;
        window.removeEventListener('visibilitychange', this.getNowTime);
      }
    },
    localJudgeComplete() {
      let isOk = true;
      for (let i = 0; i < this.localArr.length - 1; i++) {
        if (this.localArr[i] > this.localArr[i + 1]) {
          isOk = false;
        }
      }
      if (isOk) {
        this.gameOver = true;
        this.showSuccess = true;
        this.gameIsStart = false;
        window.removeEventListener('visibilitychange', this.getNowTime);
      }
    },
    localGameStart() {
      this.randomPuzzleArr();
    },
    async getGameCount() {
      if (!this.info.ptUrl) {
        this.$router.replace({ name: 'puzzleGame', query: this.$route.query });
        return;
      }
      const { id, channelNo } = this.$route.params;
      const {
        data: { data }
      } = await puzzle.challengeData({
        channelNo,
        activityId: id
      });
      !this.showBtn && (this.showBtn = true);
      const { todayCount } = data;
      this.todayCount = todayCount;
    },
    async startGame() {
      if (this.gameIsStart || (this.isEdit && !this.isPreview)) {
        return;
      }
      if (this.isPreview) {
        // 开启本地游戏
        this.localGameStart();
      } else {
        const nowTime = new Date().getTime();
        const { startDt, endDt } = this.info;
        if (startDt > nowTime) {
          this.$toast.fail('活动未开始');
          return;
        }
        if (endDt < nowTime) {
          this.$toast.fail('活动已结束');
          return;
        }
        await this.getPics();
        this.getGameCount();
      }
      this.showSuccess = false;
      let timer = null;
      this.gameIsStart = true;
      this.gameOver = false;
      this.sTime = 0;
      this.localGameIsStart = true;
      window.addEventListener('visibilitychange', this.getNowTime);
      timer = setInterval(() => {
        if (this.gameOver || this.sTime >= 99998) {
          clearInterval(timer);
          timer = null;
        } else {
          this.sTime++;
        }
      }, 10);
    },
    palyAgain() {
      this.startGame();
    },
    setLocalArr(num) {
      const arr = [];
      for (let i = 0; i < num; i++) {
        arr.push(i);
      }
      this.localArr = arr;
    },
    getNowTime() {
      const state = document.visibilityState;
      if (state == 'hidden') {
        this.hiddenTime = new Date().getTime();
      } else {
        this.sTime += (new Date().getTime() - this.hiddenTime) / 10;
      }
    }
  },
  mounted() {
    if (this.isEdit) {
      this.showBtn = true;
      this.todayCount = 2;
      this.showSuccess = this.$route.query.issuccess == 1;
    } else {
      const { id, channelNo } = this.$route.params;
      this.getActiveInfo(channelNo, id);
      this.getGameCount();
    }
    this.setLocalArr(this.info.ptNumber);
  },
  watch: {
    '$route.query.issuccess': {
      handler(newV) {
        this.showSuccess = newV == 1;
      },
      deep: true
    },
    'info.daySum': {
      handler(newV) {
        if (this.isEdit) {
          this.todayCount = newV;
        }
      },
      deep: true
    },
    'info.ptNumber': {
      handler(newV) {
        if (this.isPreview) {
          this.setLocalArr(newV);
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.puzzle {
  width: 10rem;
  overflow: hidden;
  .absolute {
    position: absolute;
  }
  .stance-1 {
    width: 100%;
    min-height: 100vh;
    position: relative;
    & > .bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    & > .title {
      width: 6.813rem;
      height: 1.6rem;
      margin-top: 1.067rem;
      left: 1.373rem;
      position: relative;
      z-index: 2;
    }
    & > .rule {
      width: 1.787rem;
      color: #fff;
      font-size: 0.8rem;
      top: 1.24rem;
      right: 0.1rem;
    }
    & > .i {
      right: 0;
      width: 2.227rem;
      height: 2.067rem;
      bottom: -0.5rem;
    }
    & > .time {
      width: 5.907rem;
      height: 0.947rem;
      border: 2px solid #fff;
      box-shadow: 0 0 5px #fff, inset 0 0 5px #fff;
      border-radius: 0.24rem;
      left: 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.2rem;
      color: #fff;
      font-size: 0.373rem;
      position: relative;
      z-index: 2;
      .number {
        width: 0.547rem;
        height: 0.547rem;
        background-color: #fda8b5;
        box-shadow: inset 0.059rem 0.089rem 0.12rem 0rem rgba(220, 40, 70, 0.42);
        border-radius: 0.107rem;
        font-size: 0.373rem;
        line-height: 1;
        color: #de2b4c;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    & > .game-box {
      width: 9.333rem;
      height: 9.333rem;
      background-color: #e85c27;
      box-shadow: -0.016rem 0.44rem 0.173rem 0rem rgba(181, 30, 55, 0.48);
      border-radius: 0.32rem;
      left: 0.32rem;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin-top: 0.5rem;
      z-index: 3;
      & > .block {
        width: 9.12rem;
        height: 9.12rem;
        background-color: #ffbdc3;
        box-shadow: inset -0.016rem -0.021rem 0.12rem 0rem
          rgba(234, 5, 98, 0.42);
        border-radius: 0.32rem;
        display: flex;
        align-items: center;
        justify-content: center;
        & > .block {
          &.big-block {
            // img {
            //   border-radius: 0.3rem;
            // }
            &.isstop {
              pointer-events: none;
            }
            .card {
              position: relative;
              img {
                position: absolute;
                left: 0;
                top: 0;
                display: inline-table;
              }
              .img-box {
                border-radius: 0.32rem;
                position: relative;
              }
            }
            &.n {
              .card {
                .img-box {
                  background-size: 7.8rem 7.8rem;
                }
                img {
                  width: 7.8rem;
                  height: 7.8rem;
                }
              }
            }
            &.m {
              .card {
                .img-box {
                  background-size: 7.8rem 7.8rem;
                }
                img {
                  width: 7.8rem;
                  height: 7.8rem;
                }
              }
            }
            &.h {
              .card {
                .img-box {
                  background-size: 7.8rem 7.8rem;
                }
                img {
                  width: 7.8rem;
                  height: 7.8rem;
                }
              }
            }
          }
          width: 8.6rem;
          height: 8.6rem;
          background-color: #bf031d;
          border-radius: 0.32rem;
          padding: 0.2rem;
          font-size: 0;
          .card {
            overflow: hidden;
            display: inline-block;
            &.move {
              opacity: 0.7;
            }
            img {
              border-radius: 0.32rem;
              pointer-events: none;
            }
          }
          position: relative;
          .move-card {
            position: absolute;
          }
          &.n {
            .card {
              width: 2.73rem;
              height: 2.73rem;
              img,
              .img-box {
                overflow: hidden;
                width: 2.613rem;
                height: 2.613rem;
              }
            }
          }
          &.m {
            .card {
              width: 2rem;
              height: 2rem;
              margin: 0.025rem;
              img,
              .img-box {
                overflow: hidden;
                width: 1.9rem;
                height: 1.9rem;
              }
            }
          }
          &.h {
            .card {
              width: 1.6rem;
              height: 1.6rem;
              margin: 0.02rem;
              img,
              .img-box {
                overflow: hidden;
                width: 1.55rem;
                height: 1.55rem;
              }
            }
          }
        }
      }
    }
    & > .btn {
      width: 6.813rem;
      height: 2.333rem;
      display: block;
      margin: 0 auto;
      margin-top: 0.7rem;
      position: relative;
      z-index: 2;
    }
    & > .tips {
      position: relative;
      z-index: 2;
      text-align: center;
      font-size: 0.373rem;
      color: #ffccce;
    }
  }
}
</style>
